import { render, staticRenderFns } from "./ProjectKPIs.vue?vue&type=template&id=0526fe4c"
import script from "./ProjectKPIs.vue?vue&type=script&lang=js"
export * from "./ProjectKPIs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports